"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyMapper = void 0;
class TaxonomyMapper {
    toTaxonomy(taxonomyResource) {
        return {
            id: taxonomyResource.id,
            createdAt: new Date(taxonomyResource.attributes.createdAt),
            updatedAt: new Date(taxonomyResource.attributes.updatedAt),
            title: taxonomyResource.attributes.title,
            description: taxonomyResource.attributes.description,
        };
    }
    toTaxonomyResource(taxonomy) {
        return {
            id: taxonomy.id,
            type: 'Taxonomy',
            attributes: {
                createdAt: taxonomy.createdAt.toISOString(),
                updatedAt: taxonomy.updatedAt.toISOString(),
                title: taxonomy.title,
                description: taxonomy.description,
            },
        };
    }
    toTaxonomyCreation(taxonomyCreationResource) {
        return {
            title: taxonomyCreationResource.attributes.title,
            description: taxonomyCreationResource.attributes.description,
        };
    }
    toTaxonomyCreationResource(taxonomyCreation) {
        return {
            type: 'Taxonomy',
            attributes: {
                title: taxonomyCreation.title,
                description: taxonomyCreation.description,
            },
        };
    }
    toTaxonomyUpdate(taxonomyUpdateResource) {
        return {
            id: taxonomyUpdateResource.id,
            title: taxonomyUpdateResource.attributes.title,
            description: taxonomyUpdateResource.attributes.description,
        };
    }
    toTaxonomyUpdateResource(taxonomyUpdate) {
        return {
            id: taxonomyUpdate.id,
            type: 'Taxonomy',
            attributes: {
                title: taxonomyUpdate.title,
                description: taxonomyUpdate.description,
            },
        };
    }
}
exports.TaxonomyMapper = TaxonomyMapper;
//# sourceMappingURL=#taxonomy-mapper.js.map